export default __webpack_public_path__ + "static/media/ks.60b35480.svg";